module.exports = __webpack_public_path__ + "static/media/chat-active.689cac18.svg";